/*
 * Authors: mariushirjanu
 * Created: 05/04/2024
 */
import * as _ from 'underscore';
import { Inject, Injectable } from '@angular/core';
import { IPaymentMatchableInvoice, IPaymentMatchData, PaymentMatchStatus } from './payment-matcher-data.service';
import { IExtendedWindow } from '../../../../type_definitions/datatypes';

export interface IPaymentMatch extends IPaymentMatchableInvoice {
  matchedAmount:number;
  highlight?:boolean;
}

@Injectable()
export class PaymentMatcherService {
  constructor(
    @Inject(Window) private window:IExtendedWindow
  ) {
    /***/
  }

  // makes a flat object
  public getPaymentMatch(paymentMatchesData:IPaymentMatchData[]):IPaymentMatch[] {
    const paymentMatchList:IPaymentMatch[] = [];
    _.each(paymentMatchesData, (paymentMatchData:IPaymentMatchData) => {
      paymentMatchList.push(_.extend(paymentMatchData.invoice, { matchedAmount: paymentMatchData.amount }));
    });
    return paymentMatchList;
  }

  public createPaymentMatchesRequest(paymentMatches:IPaymentMatch[]):IPaymentMatchData[] {
    const paymentMatchList:IPaymentMatchData[] = [];
    _.each(paymentMatches, (paymentMatch:IPaymentMatch) => {
      const invoice:IPaymentMatch = _.clone(paymentMatch);
      delete(invoice?.matchedAmount);
      delete(invoice?.highlight);
      paymentMatchList.push({
        amount: paymentMatch?.matchedAmount,
        invoice
      });
    });
    return paymentMatchList;
  }

  // Determines the grid height based on the following facts: display 2 grids on the screen, remove extra height of 210px that is part of other elements than ag-grid and keep a minimum 200px the grid
  // Ideally, we would use flexbox instead of this method. However, for now, we've decided to retain this calculation approach. We plan to implement the dialog using flexbox after we upgrade Bootstrap to the latest version and utilize the flexbox dialog feature to achieve this functionality.
  public get calcFormGridHeight():number {
    const formGridHeight:number = (this.window.innerHeight / 2) - 210;
    return formGridHeight >= 200 ? formGridHeight : 200;
  }

  public isStatusNewOrProposed = (processingStatus:PaymentMatchStatus) => processingStatus === PaymentMatchStatus.NEW || processingStatus === PaymentMatchStatus.PROPOSED;
}